import React from 'react';

const Hobbies = () => {
    return (
        <div className='hobbies'>
            <h3>Intérêts</h3>
            <ul>
                <li className='hobby'><i className='fas fa-running'></i>
                    <span>Course à pied</span>
                </li>

                <li className='hobby'><i className='fas fa-hiking'></i>
                    <span>Randonnées</span>
                </li>
                <li className='hobby'><i className='fas fa-camera'></i>
                    <span>Photographie</span>
                </li>
                <li className='hobby'><i className='fas fa-plane'></i>
                    <span>Voyages</span>
                </li>
            </ul>
        </div>
    );
};

export default Hobbies;